import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
// Tasarim sistemi + Tailwind + yazdirma kurallari tek dosyada
import '@tttrpg/ui/styles.css'

const container = document.getElementById('root')
if (!container) throw new Error('#root bulunamadi')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// PWA: service worker kaydi (masaustune kurulabilirlik + baslangic cache)
// Tarayici desteklemiyorsa sessizce gec.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* PWA olmasa da uygulama calisir */
    })
  })
}
